<style>
  /* Forzar color negro por defecto */
  .custom-item,
  .custom-item * {
    color: black !important;
    fill: black !important;
  }

  /* Hover rojo */
  .custom-item:hover {
    background-color:#F40C34 !important;
  }

  .custom-item:hover *,
  .submenu-item:hover * {
    color: white !important;
    fill: white !important;
  }

  /* Subitems también con hover rojo */
  .submenu-item {
    cursor: pointer !important;
  }

  .submenu-item:hover {
    background-color: #F40C34 !important;
  }

  /* Quitar sombreado gris de Angular Material */
  .mat-list-item.mat-focus-indicator::before {
    background: transparent !important;
  }

  /* Evitar que Material aplique estilos grises */
  .mat-list-item:hover:not(.submenu-item) {
    background-color: transparent !important;
  }
</style>

<mat-list class="!mt-16 !gap-y-8" style="background-color: white; color: black;">

  <!-- HOME -->
  <a mat-list-item routerLink="/home" class="custom-item !cursor-pointer">
    <div class="flex items-center space-x-2">
      <img src="./assets/icons/home.svg" alt="home" class="w-5 h-5" />
      <h3 class="text-base m-0">{{ 'COMPONENTS.TABS.TAB1' | translate }}</h3>
    </div>
  </a>

  <!-- DASHBOARD -->
  <a mat-list-item routerLink="/dashboard" class="custom-item !cursor-pointer">
    <div class="flex items-center space-x-2">
      <i class="material-icons">dashboard</i>
      <h3 class="text-base m-0">{{ 'COMPONENTS.MENU.DASHBOARD' | translate }}</h3>
    </div>
  </a>

    <!-- DASHBOARD -->
  <a mat-list-item routerLink="/home/promos" class="custom-item !cursor-pointer">
    <div class="flex items-center space-x-2">
      <i class="material-icons">local_offer</i>
      <h3 class="text-base m-0">{{ 'COMPONENTS.MENU.PROMOS' | translate }}</h3>
    </div>
  </a>

  <!-- PROFILE -->
  <a mat-list-item routerLink="/profile" class="custom-item !cursor-pointer">
    <div class="flex items-center space-x-2">
      <img class="w-5 h-5 rounded-full" src="./assets/icons/profile-icon.svg" alt="profile" />
      <h3 class="text-base m-0">{{ 'COMPONENTS.PROFILE.BUTTON' | translate }}</h3>
    </div>
  </a>

  <!-- RECARGA -->
  <a mat-list-item class="custom-item !cursor-pointer px-2 py-1" (click)="toggleRecarga()">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center space-x-2">
        <img src="https://cdn.zendy.tel/images/ico-recargas-black.svg" alt="recarga" class="w-5 h-5" />
        <h3 class="text-base m-0">{{ 'COMPONENTS.MENU.RECHARGE' | translate }}</h3>
      </div>
      <i class="material-icons text-base">{{ recargaOpen ? 'expand_more' : 'chevron_right' }}</i>
    </div>
  </a>

  <!-- SUBMENÚ RECARGA -->
  <div *ngIf="recargaOpen" class="ml-10 mt-1 space-y-1">
    <div class="submenu-item cursor-pointer leading-tight px-2 py-1" routerLink="/recharges">
      <div class="flex items-center gap-2">
        <i class="material-icons text-sm">call</i>
        <h5 class="text-sm font-normal leading-snug m-0">{{ 'COMPONENTS.MENU.INTERNATIONAL_CALLS' | translate }}</h5>
      </div>
    </div>

    <div class="submenu-item cursor-pointer leading-tight px-2 py-1" routerLink="/my-esims">
      <div class="flex items-center gap-2">
        <i class="material-icons text-sm">sim_card</i>
        <h5 class="text-sm font-normal leading-snug m-0">eSIM</h5>
      </div>
    </div>
  </div>

  <!-- TARIFA -->
  <a mat-list-item class="custom-item !cursor-pointer px-2 py-1" (click)="toggleTarifa()">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center space-x-2">
        <img src="https://cdn.zendy.tel/images/ico-rates-black.svg" alt="tarifa" class="w-5 h-5 " />
        <h3 class="text-base m-0">{{ 'COMPONENTS.MENU.RATES' | translate }}</h3>
      </div>
      <i class="material-icons text-base">{{ tarifaOpen ? 'expand_more' : 'chevron_right' }}</i>
    </div>
  </a>

  <!-- SUBMENÚ TARIFA -->
  <div *ngIf="tarifaOpen" class="ml-10 mt-1 space-y-1">
    <div class="submenu-item leading-tight cursor-pointer px-2 py-1" [class.opacity-60]="loadingRates" (click)="openCallRates()">
      <div class="flex items-center gap-2">
        <mat-spinner *ngIf="loadingRates" diameter="14"></mat-spinner>
        <i *ngIf="!loadingRates" class="material-icons text-sm">call</i>
        <h5 class="text-sm font-normal leading-snug m-0">
          {{ 'COMPONENTS.MENU.INTERNATIONAL_CALLS' | translate }}
        </h5>
      </div>
    </div>

    <div class="submenu-item cursor-pointer leading-tight px-2 py-1" routerLink="/esim">
      <div class="flex items-center gap-2">
        <i class="material-icons text-sm">sim_card</i>
        <h5 class="text-sm font-normal leading-snug m-0">eSIM</h5>
      </div>
    </div>
  </div>

  <!-- TERMS -->
  <a mat-list-item class="custom-item !cursor-pointer"
     (click)="window.open('https://app.zendy.tel/about/conditions', '_blank')">
    <div class="flex items-center space-x-2">
      <img src="https://cdn.zendy.tel/images/ico-conditions-black.svg" alt="conditions" class="w-5 h-5 " />
      <h3 class="text-base m-0">{{ 'COMPONENTS.MENU.CONDITIONS' | translate }}</h3>
    </div>
  </a>

  <!-- HELP -->
  <a mat-list-item class="custom-item !cursor-pointer"
     (click)="window.open('https://app.zendy.tel/about/faq', '_blank')">
    <div class="flex items-center space-x-2">
      <img src="https://cdn.zendy.tel/images/ico-help-black.svg" alt="help" class="w-5 h-5 " />
      <h3 class="text-base m-0">{{ 'COMPONENTS.MENU.HELP' | translate }}</h3>
    </div>
  </a>

  <!-- LOGOUT -->
  <a mat-list-item class="custom-item !cursor-pointer" (click)="signOut()">
    <div class="flex items-center space-x-2">
      <img src="https://cdn.zendy.tel/images/ico-logout-black.svg" class="w-5 h-5 "  />
      <h3 class="text-base m-0">{{ 'COMPONENTS.MENU.LOG_OUT' | translate }}</h3>
    </div>
  </a>

</mat-list>
